import { defineComponent as _defineComponent } from 'vue'
import { ref, watchEffect } from "../../../adapter-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  open: {
    type: Boolean,
    default: false,
  },
},
  emits: ["change"],
  setup(__props, { emit: emits }) {

const props = __props



const isSliderOpen = ref(false);



watchEffect(() => {
  isSliderOpen.value = props.open;
});

const toggleSlider = () => {
  isSliderOpen.value = !isSliderOpen.value;
  emits("change", isSliderOpen.value);
};

return { __sfc: true,props, isSliderOpen, emits, toggleSlider }
}

})